module.exports = __webpack_public_path__ + "img/log_2A_1.4b1a3940.png";